import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ServerTokensService } from '@core/services/server-tokens.service';
import { ServerEnvironments } from 'server/server-environments.enum';

@Injectable({
    providedIn: 'root'
})
export class PlatformService {
    constructor(@Inject(PLATFORM_ID) private platformId: string, private serverTokensService: ServerTokensService) {}

    public get isServer(): boolean {
        return isPlatformServer(this.platformId);
    }

    public get isBrowser(): boolean {
        return isPlatformBrowser(this.platformId);
    }

    public get isIE(): boolean {
        return (
            this.isBrowser &&
            (window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1)
        );
    }

    public get isLocal(): boolean {
        return this.serverTokensService.serverEnv === ServerEnvironments.Dev;
    }
}
